import { AutocompleteArrayInput, AutocompleteArrayInputProps, useTranslate } from 'react-admin';
import { InputLabel } from '@mui/material';

export const GrayAutocompleteArrayInputWithUpperLabel = (props: AutocompleteArrayInputProps) => {

  const translate = useTranslate();

  return (
    <>
      {props.label !== false && (
        <InputLabel className="input-label">
          {translate(typeof props.label === 'string' ? props.label : '', { _: props.label })}
        </InputLabel>
      )}
      <AutocompleteArrayInput {...props} label={false} componentsProps={{
        ...props.componentsProps,
        paper: {
          ...props.componentsProps?.paper,
          sx: {
            boxShadow: '0 2px 8px 4px lightgray',
            ...props.componentsProps?.paper?.sx,
          },
        },
      }} sx={{
        '& fieldset': {
          border: 'none',
        },
        '& .MuiOutlinedInput-root': {
          backgroundColor: '#f1f1f1 !important',
        },
      }}/>
    </>
  );

};
